

window.addEventListener("load", function () {
    initAccordion();
    initTables();
    //
  $(".header__humburger").on("click", function () {
    $(this).toggleClass("opened");
    $(".main-top-menu").toggleClass("active");
    $("html, body").toggleClass("no-scroll");
    if (!$(this).hasClass("opened"))
      $('[data-el="js-submenu"]').removeClass("active");
  });
  $('[data-el="js-open-submenu"]').on("click", function (e) {
    e.preventDefault();
    $(this).addClass("active");
    const submenuId = $(this).data("submenu-id");
    $('[data-el="js-submenu"][data-id="' + submenuId + '"]').addClass("active");
  });
  $('[data-el="js-close-submenu"]').on("click", function (e) {
    e.preventDefault();
    const submenuId =
      $(this).data("submenu-id") ??
      $(this).closest('[data-el="js-submenu"]').data("id");

    $(
      '[data-el="js-open-submenu"][data-submenu-id="' +
        submenuId +
        '"], [data-el="js-submenu"][data-id="' +
        submenuId +
        '"]'
    ).removeClass("active");
  });

  $("body").on("click", ".modal__close-button", function (e) {
    e.preventDefault();
    $(this).closest(".modal-wrapper").removeClass("active");
  });

  const currencyMaskEls = document.querySelectorAll(".currency-mask");
  currencyMaskEls.forEach((el) => {
    IMask(el, {
      mask: "num",
      blocks: {
        num: {
          mask: Number,
          thousandsSeparator: " ",
        },
      },
    });
  });

  const dateMaskEls = document.querySelectorAll(".date-mask");
  dateMaskEls.forEach((el) => {
    IMask(el, {
      mask: Date,
      min: new Date(1960, 0, 1),
      lazy: true,
    });
  });

})